import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import { ReactComponent as Background } from "assets/svgs/backgrounds/zigzag_pattern_invert.svg";
import whiteNoise from "assets/images/backgrounds/whitenoise.jpg";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backgroundContainer: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
        },
        static: {
            backgroundImage: `url(${whiteNoise})`,
            opacity: 0.04,
        },
    })
);

export default function ZigZagPatternBackground() {
    const classes = useStyles();

    return (
        <>
            <div className={clsx(classes.static, classes.backgroundContainer)} />
            <Background className={classes.backgroundContainer} />
        </>
    );
}
